import React from 'react';
import { NavLink, generatePath } from 'react-router-dom';
import IconButton from '@/components/core/IconButton';
import Tooltip from '../Tooltip';
import { cn } from '@/helpers/classnames';

interface Props {
  to: string;
  tooltip: React.ReactNode;
  icon: React.ReactNode;
  params?: Record<string, string | number>;
}

const NavButton: React.FC<Props> = ({ to, tooltip, icon, params }) => {
  return (
    <Tooltip label={tooltip}>
      <NavLink
        to={generatePath(to, params)}
        className="relative flex flex-col items-center justify-center"
        tabIndex={-1}
      >
        {({ isActive }) => (
          <>
            <IconButton
              size="lg"
              variant="ghost"
              icon={icon}
              className={cn(
                'hover:bg-white/50',
                isActive && 'border bg-white/30',
              )}
              round
            />
          </>
        )}
      </NavLink>
    </Tooltip>
  );
};

export default NavButton;
